/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Item } from '../item';
import { TooltipItem } from '../tooltip-item';
import { MenuItemProperties } from '../../../../../feature/src/lib/models/menu-item-properties';
import { FittingDefaultReturnCodes } from 'libs/sysque/toolbelt/feature/src/lib/models/fitting-default-return-codes';
import { FittingEnableDisableReturnCodes } from 'libs/sysque/toolbelt/feature/src/lib/models/fitting-enable-disable-return-codes';
import { DeleteItemReturnCodes } from 'libs/sysque/toolbelt/feature/src/lib/models/delete-item-return-codes';
import { AddFamilyInformationTypeDialog } from 'libs/sysque/toolbelt/feature/src/lib/models/family-information-model';
import { SysqueElectricalState } from 'libs/sysque/toolbelt/feature/src/lib/models/sysque-electrical-state';
import { DockableDrawingObject } from 'libs/sysque/toolbelt/feature/src/lib/models/dockable-drawing-object';
import { IFamilyInformationItem } from 'libs/sysque/toolbelt/feature/src/lib/components/add-family-information/add-family-information-types';
import { ItemReorderInfo } from '../item-reorder-info';

export interface ICategoryScopeFacade {
  windowKey: BehaviorSubject<string>;
  isTooltipOn(): Observable<boolean>;
  registerControllers(): void;
  getLocalStorageUpdate(): BehaviorSubject<string>;
  getLocalStorage(key: string): SysqueElectricalState | any;
  menuItemsUpdate(item: Item, defaultCategory: string, windowName: string, selectedCategory: string, gaugeVariable: string, releaseVersion: string): any;
  downloadFitting(itemId: string, releaseVersion: string, selectedSystem?: string): Observable<boolean>;
  getFittings(systemName: string, categoryName: string): Promise<Item[]>;
  getTooltipItemInfo(item: Item, category: string): TooltipItem[];
  setRemoveDefaultFitting(menuItemProperties: MenuItemProperties, isDefault: boolean): Promise<FittingDefaultReturnCodes>;
  enableDisableFitting(menuItemProperties: MenuItemProperties): Promise<FittingEnableDisableReturnCodes>;
  updateLocalStorage(key: string, value: any): void;
  deleteItem(menuItemProperties: MenuItemProperties): Observable<DeleteItemReturnCodes>;
  getAddFamilyInformationDialogType(item: IFamilyInformationItem): void;
  createAddFamilyInformationBasedOnItemType(dialogType: AddFamilyInformationTypeDialog): void;
  sendDrawingOptions(drawingAction: string, drawingObjectProperties: DockableDrawingObject): Observable<boolean>;
  getSysqueConnectState(): boolean;
  getManageSrcState(): SysqueElectricalState;
  updateManageSrcStateFittingListProperty(srcState : SysqueElectricalState): void;
  getDockedState(): SysqueElectricalState;
  updateManageDestStateFittingListPropertyForCopiedItem(state: SysqueElectricalState, item: Item): void;
  updateManageDestStateFittingListProperty(state: SysqueElectricalState): void;
  updateLocalStorageForEditDuplicateAlert(key: string, value: any): void;
  saveNewFittingsOrder(items: ItemReorderInfo[], systemName: string, categoryName: string): void;
  showReportIssue(fittingId: string): Observable<any>;
}

export const CATEGORY_SCOPE_FACADE_TOKEN = new InjectionToken<ICategoryScopeFacade>('CATEGORY_SCOPE_FACADE_TOKEN');